/**
 *
 * UserImage
 *
 */

import React, { Fragment } from "react"
import { Table, Popover, Dropdown, Menu, Tooltip } from "antd"
import { flatMap, map } from "lodash"
import checkIcon from "images/check.svg"
import TruncateText from "components/TruncateText"
import pointMenu from "images/three-points-gray.svg"
import imgDelete from "images/delete-red.svg"
import imgEdit from "images/pencil-gray.svg"
import questionIcon from "images/question.svg"
import "./index.less"

class TableRecommendations extends React.Component {
  state = { sortedInfo: null }

  handleChange = (pagination, filters, sorter) => {
    this.setState({ sortedInfo: sorter })
  }

  render() {
    let { sortedInfo } = this.state
    const { data } = this.props
    sortedInfo = sortedInfo || {}

    const columns = [
      {
        width: "35%",
        title: "Plan de acción",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
        render: (name, record) => {
          return (
            <Popover
              placement="bottom"
              content={
                <div style={{ width: 450, textAlign: "justify" }}>
                  <p>
                    <b>{name}</b>
                  </p>
                  <p>{record.description}</p>
                  <div className="RecommendationsTable-popover-task">
                    {record.tasks.map((t) => (
                      <span key={t.id_recommendation_task}>
                        <img src={checkIcon} /> {t.name}
                      </span>
                    ))}
                  </div>
                </div>
              }>
              <TruncateText line={2} text={name} truncateText="…" />
            </Popover>
          )
        },
      },
      {
        width: "25%",
        title: "Dimensión",
        dataIndex: "dimensions",
        key: "dimensions",
        render: (text, record) => {
          if (text.length === 0) return "-"
          const convert = flatMap(text, (item) => item.dimension_name)
          const separate = convert.slice(0, 2).join(", ")
          const rest = convert.slice(2, text.length)
          const tooltipText = () => {
            return (
              <div
                className="collaborators-team-tooltip"
                style={{ maxHeight: 100, overflow: "auto" }}>
                {map(rest, (item, index) => {
                  return <span key={index}>{item}</span>
                })}
              </div>
            )
          }

          return (
            <Fragment>
              <span>{separate}</span>
              {text.length > 2 ? (
                <Fragment>
                  <span>, </span>{" "}
                  <Tooltip placement="top" title={tooltipText}>
                    <span
                      style={{ display: "inline-block", verticalAlign: "top" }}
                      className="hover-underline">
                      {" "}
                      +{text.length - 2}
                    </span>
                  </Tooltip>
                </Fragment>
              ) : null}
            </Fragment>
          )
        },
      },
      {
        width: "15%",
        title: "Última modificación",
        dataIndex: "updated_at",
        key: "updated_at",
        sorter: (a, b) => {
          const dateA = a.updated_at
            .split("/")
            .reverse()
            .join("-")
          const dateB = b.updated_at
            .split("/")
            .reverse()
            .join("-")
          return new Date(dateA).getTime() - new Date(dateB).getTime()
        },
        sortOrder: sortedInfo.columnKey === "updated_at" && sortedInfo.order,
      },
      {
        width: "10%",
        title: "Tareas",
        dataIndex: "tasks",
        key: "tasks",
        render: (_) => <span>{_.length}</span>,
        sorter: (a, b) => a.tasks.length - b.tasks.length,
        sortOrder: sortedInfo.columnKey === "tasks" && sortedInfo.order,
      },
      {
        width: "9%",
        title: () => {
          const icon = (
            <Popover
              placement="topRight"
              content={
                <span style={{ width: 159, display: "block" }}>
                  Número de usuarios que han seleccionado el plan
                </span>
              }>
              <img
                src={questionIcon}
                alt="question"
                style={{
                  marginLeft: 4,
                  cursor: "pointer",
                  position: "absolute",
                  top: "50%",
                  left: 85,
                  transform: "translate(-50%, -50%)",
                }}
              />
            </Popover>
          )
          return <div>En uso {icon}</div>
        },
        dataIndex: "used",
        key: "used",
        sorter: (a, b) => a.used - b.used,
        sortOrder: sortedInfo.columnKey === "used" && sortedInfo.order,
      },
      {
        width: "4%",
        title: "",
        dataIndex: "options",
        key: "options",
        render: (row, record) => {
          return (
            <Dropdown
              trigger={["click"]}
              placement="bottomRight"
              overlay={
                <Menu>
                  <Menu.Item onClick={(e) => this.props.onEdit(record)}>
                    <img src={imgEdit} height={10} /> Editar
                  </Menu.Item>
                  <Menu.Item
                    onClick={(e) => this.props.onDelete(record)}
                    style={{ color: "#EA6364" }}>
                    <img src={imgDelete} height={10} /> Eliminar
                  </Menu.Item>
                </Menu>
              }>
              <img style={{ cursor: "pointer", padding: 5 }} src={pointMenu} />
            </Dropdown>
          )
        },
      },
    ]

    return (
      <div className="RecommendationsTable" >
        <Table 
          dataSource={data}
          columns={columns}
          onChange={this.handleChange}
          rowKey="id_recommendation"
          pagination={{
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
            defaultPageSize: 15,
          }}
        />
      </div>
    )
  }
}

TableRecommendations.propTypes = {}

export default TableRecommendations
